import React, { useState, useRef } from 'react'
import { Formik, Form } from 'formik'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Typography, Icon } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'

import CloseWarning from 'module/leave/pages/leaveDetailsRequirementImport/components/CloseWarning'
import LeaveDetailsImportForm from 'module/leave/pages/leaveDetailsRequirementImport/view/LeaveDetailsImportForm'

import { useMutation } from 'react-query'
import { handleValidationErrors } from 'services/helper/handleValidationErrors'

// API
import { postCheckLeaveDetailsBulkImport } from 'services/api/modules/leave/bulkImport'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'

const LeaveDetailsRequirementsImport = ({ state }) => {
  const formikRef = useRef()
  const navigate = useNavigate()
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }
  const [pageState, setPageState] = useState('FILL_DETAILS')
  const location = state.backgroundLocation
  const [errorResponse, setErrorResponse] = useState('')
  const handleCloseModal = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    navigate(-1)
  }

  //call api
  const mutation = useMutation(postCheckLeaveDetailsBulkImport, {
    onSuccess: (response) => {
      navigate('/app/management-centre/company-management/leave/leave-details/import', {
        state: {
          backgroundLocation: location,
          staffData: response.data,
        },
      })
    },
    onError: (error) => {
      setErrorResponse(error?.data?.message)
      if (error.status === 422) {
        handleValidationErrors(error, formikRef)
        console.log(error)
      } else {
        console.log(error.data.message)
      }
    },
  })

  const handleUploadImport = async (values) => {
    if (pageState === 'FILL_DETAILS') {
      let newData = values.file[0]
      let formData = new FormData()
      formData.append('file', newData)

      mutation.mutate(formData)
    }
  }

  return (
    <AdxFormModal
      open={true}
      onClose={handleOpen}
      handleClose={handleOpen}
      disableEscapeKeyDown
      disableAutoFocus
      title={"Import staff's leave details"}
    >
      <Formik
        enableReinitialize
        initialValues={{
          file: null,
        }}
        onSubmit={handleUploadImport}
        innerRef={formikRef}
      >
        {(formikProps) => (
          <>
            <Form>
              {pageState === 'FILL_DETAILS' && (
                <>
                  <LeaveDetailsImportForm formikProps={formikProps} errorResponse={errorResponse} />
                </>
              )}
            </Form>
          </>
        )}
      </Formik>
      <AdxInfoModal
        variant={'warning'}
        open={isModalOpen}
        onClose={handleClose}
        muiIcon="warning"
        iconColor="error.main"
        title="Would you like to exit this page?"
        subtitle="Any unsaved changes will be discarded"
        footerButtons
        firstBtnLabel={'Confirm'}
        firstBtnHandle={() => navigate('/app/management-centre/company-management/leave')}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleClose}
      />
    </AdxFormModal>
  )
}

export default LeaveDetailsRequirementsImport
